export default "__VITE_ASSET__ByDlBPMv__"